(function(){
var H=document.getElementById('wwh');if(!H)return;
var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
var $$=function(r,s){return Array.prototype.slice.call(r.querySelectorAll(s))};
var esc=function(s){var d=document.createElement('div');d.textContent=s||'';return d.innerHTML};

/* announcement rotation */
var A=H.querySelector('[data-ann]');
if(A){var sp=$$(A,'span'),k=0;if(sp.length>1&&!matchMedia('(prefers-reduced-motion: reduce)').matches)setInterval(function(){if(document.hidden)return;sp[k].classList.remove('on');k=(k+1)%sp.length;sp[k].classList.add('on')},4500)}

/* drawers */
var cur=null,last=null;
function close(kb){if(!cur)return;cur.hidden=true;cur=null;document.documentElement.style.overflow='';if(kb&&last&&last.focus)last.focus();else if(document.activeElement&&document.activeElement.blur)document.activeElement.blur();last=null}
function show(id,btn){var d=document.getElementById(id);if(!d)return;if(cur)cur.hidden=true;else last=btn;d.hidden=false;cur=d;document.documentElement.style.overflow='hidden';var f=d.querySelector('[data-sq]')||d.querySelector('.cl');setTimeout(function(){f&&f.focus()},40)}
H.addEventListener('click',function(e){
 var b=e.target.closest('[data-open]');if(b){e.preventDefault();show(b.dataset.open,b);return}
 if(e.target.closest('[data-close]')){close(e.detail===0);return}
 var c=e.target.closest('[data-cart]');if(c){e.preventDefault();openCart()}
});
document.addEventListener('keydown',function(e){if(e.key==='Escape'&&cur)close(true)});

/* cart */
var cc=H.querySelector('[data-cc]');
function openCart(){document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true,detail:{open:true}}))}
function count(){fetch(root+'cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json()}).then(function(c){if(cc)cc.textContent=c.item_count}).catch(function(){})}
var of=window.fetch;
window.fetch=function(){var a=arguments,u=a[0];u=typeof u==='string'?u:(u&&u.url)||'';var p=of.apply(window,a);if(/cart.(add|change|update|clear)/.test(u))p.then(function(){setTimeout(count,300)},function(){});return p};
document.addEventListener('cart:refresh',function(){setTimeout(count,500)});
addEventListener('pageshow',function(e){if(e.persisted)count()});

/* predictive search */
var sq=H.querySelector('[data-sq]'),sr=H.querySelector('[data-sres]'),pop=H.querySelector('[data-spop]'),t,seq=0;
var money=function(v){var n=+v;return '£'+(n%1===0?n.toLocaleString('en-GB'):n.toLocaleString('en-GB',{minimumFractionDigits:2,maximumFractionDigits:2}))};
if(sq&&sr){sq.addEventListener('input',function(){
 clearTimeout(t);var q=sq.value.trim();
 if(q.length<2){sr.innerHTML='';if(pop)pop.hidden=false;return}
 t=setTimeout(function(){var my=++seq;
  fetch(root+'search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=last').then(function(r){return r.json()}).then(function(j){
   if(my!==seq)return;
   var P=(j.resources&&j.resources.results&&j.resources.results.products)||[];
   if(pop)pop.hidden=P.length>0;
   sr.innerHTML=P.length?P.map(function(p){var im=p.image?p.image+(p.image.indexOf('?')>-1?'&':'?')+'width=120':'';return '<a class="it" href="'+p.url+'">'+(im?'<img src="'+im+'" alt="" loading="lazy">':'<span class="ph"></span>')+'<span>'+esc(p.title.split(' | ')[0])+'</span><small>'+(p.price_max!==p.price_min?'From ':'')+money(p.price_min||p.price)+'</small></a>'}).join('')+'<a class="sall" href="'+root+'search?q='+encodeURIComponent(q)+'">See all results</a>':'<p class="none">No products found for “'+esc(q)+'”.</p>';
  }).catch(function(){})},220)});
}
})();